/* aaa-anchor-scroll: in-page smooth scroll for the hero "Enter the shop"
 * button. The hero primary button links to #shop; this scrolls to the shop
 * (collection-list) section, offset for the sticky header. The target is
 * suffix-matched so it survives template-id changes.
 *
 * Tinker 4.1.1 scrolls a `.page-wrapper` container (html/body are
 * overflow:hidden), NOT the window — so window.scrollTo() is a no-op here.
 * We therefore scroll the target's nearest scrollable ancestor and compute
 * the offset relative to it, falling back to the window scroller if the page
 * scrolls normally. Uses behavior:'instant' because the theme's scroll
 * machinery reverts non-instant programmatic scrolls on .page-wrapper back
 * to 0; instant lands reliably on the shop section. */
const AAA_ANCHOR_TARGETS = { '#shop': '[id$="collection_list_rooms"]' };

/* Nearest ancestor that actually scrolls; null => the document/window scrolls. */
function aaaScrollParent(el) {
  let n = el ? el.parentElement : null;
  while (n && n !== document.documentElement && n !== document.body) {
    const cs = getComputedStyle(n);
    if (/(auto|scroll)/.test(cs.overflowY) && n.scrollHeight > n.clientHeight) return n;
    n = n.parentElement;
  }
  return null;
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href$="#shop"]');
  if (!link) return;
  const sel = AAA_ANCHOR_TARGETS['#shop'];
  const target = sel && document.querySelector(sel);
  if (!target) return;
  event.preventDefault();

  const header = document.querySelector('#header-component, .header');
  const offset = (header ? header.getBoundingClientRect().height : 0) + 8;
  const scroller = aaaScrollParent(target);

  if (scroller) {
    const y =
      target.getBoundingClientRect().top -
      scroller.getBoundingClientRect().top +
      scroller.scrollTop -
      offset;
    scroller.scrollTo({ top: y, behavior: 'instant' });
  } else {
    const y = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y, behavior: 'instant' });
  }
});
